const isNum = n => typeof n === 'number' && !isNaN(n);
const isNotNum = n => !isNum(n);

export { isNum, isNotNum };
